<div class="form-check form-group" [ngClass]="{ required: markAsRequired, valid: markAsValid }">
	<div class="checkbox-container">
		<input
			class="form-check-input"
			[ngClass]="{ 'is-invalid': isInvalid(control), 'no-label': !label && !inputHtml }"
			type="checkbox"
			[name]="name"
			[formControl]="control"
			[id]="id"
			[tabindex]="tabIndex"
			[value]="value"
		/>
		<span class="checkbox-icon-wrapper">
			<i class="cfe cfe-done checkbox-icon"></i>
		</span>

		<div class="icon-wrapper" *ngIf="icon">
			<i [ngClass]="icon" class="custom-icon"></i>
		</div>
		<div
			class="row label-container"
			[ngStyle]="{ 'align-items': centerLabelVertical ? 'center' : null, 'margin-left': icon ? '5px' : '25px' }"
		>
			<div class="col-12 terms-and-conditions-text-flex">
				<label *ngIf="label" [ngStyle]="labelStyles">
					{{ label }}
				</label>
				<div *ngIf="inputHtml">
					<label [ngStyle]="labelStyles" [innerHTML]="htmlCode"></label>
				</div>
				<div *ngIf="smallLabel" class="small-label">
					<small>{{ smallLabel }}</small>
				</div>
				<div class="invalid-feedback mt-0" *ngIf="isInvalid(control) && showError" [ngStyle]="{ display: 'block' }">
					<small *ngIf="inputErrors(control, 'pattern') != false">
						<span>{{
							'terms.error.checkboxNotAcceptedErrorMessage' | translate: { termsAndConditions: 'terms.termsAndConditions' | translate }
						}}</span>
					</small>
				</div>
			</div>
		</div>
	</div>
</div>
